import {useState} from "react";
import {gql, useMutation} from "@apollo/client";
import {useResult} from "@betrue/common-front";
import {FileApi} from "@betrue/common/shared";
import {BASE_ENTITY_FIELDS} from "../graphql/base-fields";
import {File, FILES_API_PATH} from "@betrue/shared/interfaces";
import {CONFIG} from "@betrue/ui";
import {ImageShape} from "@betrue/store-locator-shared";


export const CORE_FILE_FIELDS = gql`

  fragment CoreFileField on FileModel{
    ${BASE_ENTITY_FIELDS}
    encoding
    filename
    mimetype
    size
  }
`;

const UPLOAD_FILE = gql`
  ${CORE_FILE_FIELDS}
  mutation fileUpload($file: Upload!) {
    uploadFile(file: $file) {
      ...CoreFileField
    }
  }
`;

const DELETE_FILE = gql`
  ${CORE_FILE_FIELDS}
  mutation deleteFile($id: String!) {
    deleteFile(id: $id){
      ...CoreFileField
    }
  }
`;

export const fileUrl = (file?: File, size?: number, shape?: ImageShape) => {
  return file ? encodeURI(`${window.FRONT_CONFIG.restApiUrl}/${FILES_API_PATH}/${file.filename}?id=${file.id}${size ? '&size=' + size : ''}${shape ? '&shape=' + shape : ''}`) : ''
}

export const useFile = <T = File | File[]>(initial?: T): [T, FileApi] => {
  const [result, setResult] = useState<T>(initial);
  const uploadFile = useResult(useMutation(UPLOAD_FILE), setResult)
  const deleteFile = useResult(useMutation(DELETE_FILE, {}), setResult)

  return [
    result,
    {
      deleteFile(id: string) {
        deleteFile({
          variables: {
            id: id
          }
        })
      },
      uploadFile(file: any) {
        console.log('upload ', file)
        uploadFile({
          variables: {
            file: file
          }
        })
      }
    }]
}
